module.exports = __webpack_public_path__ + "static/media/onboarding-history.es.74ad30cc.png";